// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__1w0tR","icon_szukaj":"Szukaj_icon_szukaj__TLRq+","icon_clear":"Szukaj_icon_clear__GJccs","szukajInput":"Szukaj_szukajInput__HOyC4","icon2":"Szukaj_icon2__1ZuLA"};